<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5" :key="reloadItems + 1">
        <span>{{ title }}</span>
      </div>
    </v-card>
    <v-card-text>
      <paginated-search-table
        endpoint="/data/comunications_view"
        ordering="-date"
        searchLabel="Asunto"
        :headers="tableHeaders"
        :canEdit="false"
        :canAdd="false"
        :canDelete="false"
        :showSearch="false"
        :canViewDocument="false"
        :messageStatus="true"
        :key="reloadItems"
        @itemSelected="itemSelected($event, false)"
      ></paginated-search-table>
    </v-card-text>
  </v-card>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";

export default {
  name: "ComunicationViewer",

  components: {
    PaginatedSearchTable
  },

  data: () => ({
    title: "Comunicaciones",
    currentItem: null,
    editMode: null,
    reloadItems: 0,
    tableHeaders: [
      { text: "Fecha", value: "formatted_date", sortable: false },
      {
        text: "Asunto",
        value: "subject",
        sortable: false
      },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  }),

  methods: {
    async itemSelected(args) {
      //asesores no pueden leer notificaciones
      if (this.$bRoot.auth.current_level <= 3) {
        //mostrar documento
        window.open(args.document, "_blank", "noreferrer");

        if (!args.readed === true) {
          let comu_come = {
            commercial_person: args.commercial_person,
            comunication: args.comunication,
            read: true
          };
          try {
            let added = await this.$bRoot.add(
              "/data/commercial_persons_comunications",
              "commercial_person__id=" +
                args.commercial_person_id +
                "&comunication__id=" +
                args.comunication_id,
              comu_come
            );
            if (added) {
              await this.$bRoot.auth.updateUserState();
              this.updateStatus();
              this.reloadItems += 1;
            } else {
              throw "El registro no se guardo";
            }
          } catch (error) {
            if (!this.$bRoot.Errors) {
              this.$bRoot.setError(error);
            }
          }
        }
      }
    },

    updateStatus() {
      if (
        this.$bRoot.auth.avoid_navigation === true &&
        !this.$bRoot.auth.password_expired
      ) {
        this.title =
          "Comunicaciones - para continuar por favor lea los mensajes pendientes...";
      } else {
        this.title = "Comunicaciones";
      }
    }
  },

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.$bRoot.errors = null;
    this.updateStatus();
  }
};
</script>
